import store from '../store';

export default function authMiddleware({ next }) {
  const isLoggedIn = store.getters['auth/getLoggedIn'];

  if (!isLoggedIn) {
    return next({ name: 'login' }); // ✅ tell the router to redirect
  }

  return next(); // ✅ always call next
}
